module.exports = __webpack_public_path__ + "img/glasses_male_round_mask.1eb4c1cf.png";